import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-table-widget',
  templateUrl: './table.widget.html'
})
export class MyTableWidgetComponent extends ControlWidget {

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/table/table.widget.ts